
import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({

  inline: {
    display: 'inline',
    width: '100%',
    maxWidth: '50rem',
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  center: {
    flexGrow: 1,
    margin: '10px',
    display: 'flex',
    justifyContent: 'center',
  },
  cardBody: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    margin: 0,
    maxHeight: 'inherit',
    paddingButton: theme.spacing(2),
    paddingTop: theme.spacing(2),
    overflow: 'auto'
  },

}
))
